export default __webpack_public_path__ + "static/media/d_wdt_c_0.5dd55c2d.mp3";